import React from 'react';

import * as S from './salary-forecast-bar.styles';

type Props = {
  headlineCopy?: string;
  isFullRange?: boolean;
  isUpsell?: boolean;
  legendCopies?: {
    left: string;
    right: string;
  };
  barPosition?: number;
};

export const SalaryForecastBar: React.VFC<Props> = ({
  headlineCopy,
  isFullRange,
  isUpsell,
  legendCopies,
  barPosition,
}) => {
  const hasRangePosition = typeof barPosition === 'number';

  return (
    <S.ForecastContainer $hasRangePosition={hasRangePosition}>
      {headlineCopy && (
        <S.BarHeadline size="medium" $position={barPosition}>
          {headlineCopy}
        </S.BarHeadline>
      )}
      <S.ForecastBar $isFullRange={isFullRange} $isUpsell={isUpsell} $hasRangePosition={hasRangePosition}>
        {!isFullRange && (isUpsell ? <S.UpsellRangeBar /> : <S.RangeBar $position={barPosition} />)}
      </S.ForecastBar>
      {legendCopies && (
        <S.LegendContainer>
          <S.LegendCopy>{legendCopies.left}</S.LegendCopy>
          <S.LegendCopy>{legendCopies.right}</S.LegendCopy>
        </S.LegendContainer>
      )}
    </S.ForecastContainer>
  );
};
